import React, { useState } from "react";
import "../styles/AlertModal.scss";

interface AlertModalState {
  isOpen: boolean;
  title: string;
  body: React.ReactNode;
}

const useAlertModal = () => {
  const [modalState, setModalState] = useState<AlertModalState>({
    isOpen: false,
    title: "",
    body: "",
  });

  const openModal = (title: string, body: React.ReactNode) => {
    setModalState({ isOpen: true, title, body });
  };

  const closeModal = () => {
    setModalState({ isOpen: false, title: "", body: "" });
  };

  const AlertModal: React.FC = () => {
    if (!modalState.isOpen) {
      return null;
    }

    return (
      <div className="alert-modal-overlay">
        <div className="alert-modal">
          <div className="alert-modal-header">
            <div className="alert-modal-title">{modalState.title}</div>
            <button onClick={closeModal} className="alert-modal-close-button">
              &times;
            </button>
          </div>
          <div className="alert-modal-body">{modalState.body}</div>
        </div>
      </div>
    );
  };

  return {
    openModal,
    closeModal,
    AlertModal,
    isModalOpen: modalState.isOpen,
  };
};

export default useAlertModal;
